var render = function render(){var _vm=this,_c=_vm._self._c;return _c('sf-content-layout',{scopedSlots:_vm._u([{key:"title",fn:function(){return [_c('sf-content-title',{attrs:{"title":_vm.title}})]},proxy:true},{key:"content",fn:function(){return [_c('sf-sitemap',{attrs:{"menu":_vm.menu},on:{"menuClick":_vm.menuClick}})]},proxy:true}])})
}
var staticRenderFns = []

export { render, staticRenderFns }